import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Settings }                             from "@material-ui/icons";
import * as React                               from "react";
import { FC }                                   from "react";
import { useDispatch }                          from "react-redux";
import MenuType                                 from "../../../domain/menu/MenuType";
import RouterDispatcher                         from "../../../infrastructure/redux/router/RouterDispatcher";
import "./MenuList.scss";

interface Props {
  menuType: MenuType;
}

const MenuListNoticeButton: FC<Props> = (props: Props) => {
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  const {menuType} = props;
  return (
    <>
      {
        menuType === MenuType.SETTING
          ?
          <section className="reska-menu-selected">
            <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.setting() }>
              <ListItemIcon>
                <Settings/>
              </ListItemIcon>
              <ListItemText primary="設定" className="reska-menu-selected-text"/>
            </ListItem>
          </section>
          :
          <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.setting() }>
            <ListItemIcon>
              <Settings/>
            </ListItemIcon>
            <ListItemText primary="設定"/>
          </ListItem>
      }
    </>
  );
};

export default MenuListNoticeButton;
